import * as t from 'io-ts';

const FreeTrialStatusCodec = t.union([
    t.literal('ACTIVE'),
    t.literal('ELIGIBLE'),
    t.literal('INELIGIBLE'),
    t.literal('INACTIVE'),
    t.literal('active'),
    t.literal('eligible'),
    t.literal('ineligible'),
    t.literal('inactive'),
]);

export const FreeTrialApiResponseCodec = t.intersection([
    t.type({
        account_id: t.string,
        account_name: t.string,
        status: FreeTrialStatusCodec,
    }),
    t.partial({
        activated_at: t.union([t.string, t.null]),
        ends_at: t.union([t.string, t.null]),
    }),
]);

export type FreeTrialApiResponse = t.TypeOf<typeof FreeTrialApiResponseCodec>;
